import Styles from './styles';
import {Colors, Opacity} from "./colors";
import {Images} from './images';
const Setting = {
    name: 'Shop2Support',
    domain: 'https://shop2support.com',
    defaultFont: 'ProximaNova',
    fontSupport: ['ProximaNova', 'SFProText', 'Raleway'],
    resourcesFont: {
        'ProximaNova-Black': require('../assets/fonts/ProximaNova-Black.otf'),
        'ProximaNova-Bold': require('../assets/fonts/ProximaNova-Bold.otf'),
        'ProximaNova-ExtraBold': require('../assets/fonts/ProximaNova-ExtraBold.otf'),
        'ProximaNova-Regular': require('../assets/fonts/ProximaNova-Regular.otf'),
        'ProximaNova-Thin': require('../assets/fonts/ProximaNova-Thin.otf'),
        'Raleway-Black': require('../assets/fonts/Raleway-Black.ttf'),
        'Raleway-BlackItalic': require('../assets/fonts/Raleway-BlackItalic.ttf'),
        'Raleway-Bold': require('../assets/fonts/Raleway-Bold.ttf'),
        'Raleway-BoldItalic': require('../assets/fonts/Raleway-BoldItalic.ttf'),
        'Raleway-ExtraBold': require('../assets/fonts/Raleway-ExtraBold.ttf'),
        'Raleway-ExtraBoldItalic': require('../assets/fonts/Raleway-ExtraBoldItalic.ttf'),
        'Raleway-ExtraLight': require('../assets/fonts/Raleway-ExtraLight.ttf'),
        'Raleway-ExtraLightItalic': require('../assets/fonts/Raleway-ExtraLightItalic.ttf'),
        'Raleway-Italic': require('../assets/fonts/Raleway-Italic.ttf'),
        'Raleway-Light': require('../assets/fonts/Raleway-Light.ttf'),
        'Raleway-LightItalic': require('../assets/fonts/Raleway-LightItalic.ttf'),
        'Raleway-Medium': require('../assets/fonts/Raleway-Medium.ttf'),
        'Raleway-MediumItalic': require('../assets/fonts/Raleway-MediumItalic.ttf'),
        'Raleway-Regular': require('../assets/fonts/Raleway-Regular.ttf'),
        'Raleway-SemiBold': require('../assets/fonts/Raleway-SemiBold.ttf'),
        'Raleway-SemiBoldItalic': require('../assets/fonts/Raleway-SemiBoldItalic.ttf'),
        'Raleway-Thin': require('../assets/fonts/Raleway-Thin.ttf'),
        'Raleway-ThinItalic': require('../assets/fonts/Raleway-ThinItalic.ttf'),
        'SFProText-Black': require('../assets/fonts/SFProText-Black.ttf'),
        'SFProText-Bold': require('../assets/fonts/SFProText-Bold.ttf'),
        'SFProText-Heavy': require('../assets/fonts/SFProText-Heavy.ttf'),
        'SFProText-Light': require('../assets/fonts/SFProText-Light.ttf'),
        'SFProText-Medium': require('../assets/fonts/SFProText-Medium.ttf'),
        'SFProText-Regular': require('../assets/fonts/SFProText-Regular.ttf'),
        'SFProText-Semibold': require('../assets/fonts/SFProText-Semibold.ttf'),
        'SFProText-Thin': require('../assets/fonts/SFProText-Thin.ttf'),
        'SFProText-Ultralight': require('../assets/fonts/SFProText-Ultralight.ttf'),
    },
}
export {Styles, Setting, Colors, Opacity, Images};
